(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
    if (!bar.classList.contains('announcement-bar--rotate')) return;
    const all = [...bar.querySelectorAll('[data-announcement-item]')].sort(
      (a, b) => Number(a.dataset.order || 0) - Number(b.dataset.order || 0)
    );
    if (all.length < 2) return;

    const interval = parseFloat(getComputedStyle(bar).getPropertyValue('--announcement-interval')) * 1000 || 4000;
    const mobile = window.matchMedia('(max-width: 989px)');
    const phone = window.matchMedia('(max-width: 749px)');
    let timer = null;

    // the messages shown at this width (phones get the parts of a " · " message instead of the whole line)
    const visible = () => all.filter((item) => getComputedStyle(item).display !== 'none');
    const activate = (item) => all.forEach((other) => other.classList.toggle('is-active', other === item));

    const show = (step) => {
      const items = visible();
      if (!items.length) return;
      const at = items.findIndex((item) => item.classList.contains('is-active'));
      activate(items[(at + step + items.length) % items.length]);
    };

    const start = () => {
      const items = visible();
      if (items.length && !items.some((item) => item.classList.contains('is-active'))) activate(items[0]);
      if (timer || !mobile.matches || items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => show(1), interval);
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };

    // Tablets: measured with the whole messages in place; phones always get the parts (CSS)
    const tablet = window.matchMedia('(min-width: 750px) and (max-width: 989px)');
    const list = bar.querySelector('[data-announcement-list]');
    const fit = () => {
      bar.classList.remove('announcement-bar--parts');
      if (!tablet.matches || !list) return;
      const room = list.clientWidth;
      const tooLong = [...list.querySelectorAll('.announcement-bar__item--full .announcement-bar__link')].some(
        (link) => link.offsetWidth > room
      );
      bar.classList.toggle('announcement-bar--parts', tooLong);
    };
    const refit = () => {
      const before = bar.classList.contains('announcement-bar--parts');
      fit();
      if (bar.classList.contains('announcement-bar--parts') !== before) {
        stop();
        start();
      }
    };
    let frame = 0;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(refit);
    });
    if (document.fonts) document.fonts.ready.then(refit);

    mobile.addEventListener('change', () => (mobile.matches ? start() : stop()));
    phone.addEventListener('change', () => {
      stop();
      start();
    });
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    fit();
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Beschikbaarheid: Shopify's aantallen kloppen niet zolang er geen beschikbaarheid gekozen is (nieuwere producten
  // tellen als niet op voorraad). Met 'op voorraad' aan klopt het totaal wel: dat ophalen en de aantallen invullen.
  document.querySelectorAll('[data-availability-fix]').forEach(async (list) => {
    const root = list.closest('[data-section-id]');
    const total = Number(root?.dataset.productsCount);
    let inStock = NaN;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('filter.v.availability', '1');
      url.searchParams.delete('page');
      url.searchParams.set('section_id', root.dataset.sectionId);
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (response.ok) {
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        inStock = Number(doc.querySelector('[data-products-count]')?.dataset.productsCount);
      }
    } catch (error) {
      inStock = NaN;
    }
    if (Number.isNaN(inStock) || Number.isNaN(total)) {
      list.dataset.availabilityFix = 'failed';
      return;
    }
    const counts = { 1: inStock, 0: Math.max(0, total - inStock) };
    list.querySelectorAll('[data-availability-value]').forEach((item) => {
      const count = counts[item.dataset.availabilityValue];
      if (count === undefined) return;
      const countElement = item.querySelector('.collection-products__filter-count');
      if (countElement) countElement.textContent = count;
      item.hidden = count === 0;
      // Shopify disabled an option it counted as 0: enable it when there is something behind it
      if (count > 0) {
        item.querySelector('input')?.removeAttribute('disabled');
        item.querySelector('.collection-products__filter-option')?.classList.remove('is-disabled');
      }
    });
    // 'Op voorraad' always first, also when it was added because Shopify left it out
    const inStockItem = list.querySelector('[data-availability-value="1"]');
    if (inStockItem && inStockItem !== list.firstElementChild) list.prepend(inStockItem);
    if (![...list.querySelectorAll('[data-availability-value]')].some((item) => !item.hidden)) {
      list.closest('.collection-products__filter-group')?.setAttribute('hidden', '');
    }
    list.dataset.availabilityFix = 'done';
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('.collection-products').forEach((root) => {
    const panel = root.querySelector('[data-filters-panel]');
    const toggle = root.querySelector('[data-filters-toggle]');
    const form = root.querySelector('[data-filters-form]');
    if (!panel) return;

    const setOpen = (open) => {
      panel.classList.toggle('is-open', open);
      toggle?.setAttribute('aria-expanded', String(open));
      root.querySelectorAll('.collection-products__filters-backdrop').forEach((backdrop) => (backdrop.hidden = !open));
      document.body.classList.toggle('header-drawer-open', open);
    };

    toggle?.addEventListener('click', () => setOpen(!panel.classList.contains('is-open')));
    root.querySelectorAll('[data-filters-close]').forEach((closer) => closer.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });

    // Empty price fields must not end up in the URL (an empty "price to" would filter everything out)
    form?.addEventListener('submit', () => {
      form.querySelectorAll('input[type="number"]').forEach((input) => {
        if (input.value.trim() === '') input.disabled = true;
      });
    });

    // Desktop: apply checkbox filters immediately; price inputs on change
    const desktop = window.matchMedia('(min-width: 990px)');
    form?.addEventListener('change', (event) => {
      if (!desktop.matches) return;
      const target = event.target;
      if (target.matches('input[type="checkbox"]') || target.matches('input[type="number"]')) {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });

      this._links = Array.from(this.querySelectorAll('[data-faq-nav]'));
      this._groups = this._links.map((link) => this.querySelector('#' + link.dataset.faqNav)).filter(Boolean);
      if (!this._links.length || !this._groups.length) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const group = this.querySelector('#' + link.dataset.faqNav);
          if (!group) return;
          event.preventDefault();
          group.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + link.dataset.faqNav);
          this._setActive(link.dataset.faqNav);
        });
      });

      this._setActive(this._groups[0].id);
      if (!('IntersectionObserver' in window)) return;
      this._visible = new Map();
      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => this._visible.set(entry.target.id, entry.isIntersecting ? entry.boundingClientRect.top : null));
          // The active topic is the visible group closest to the top of the viewport.
          let best = null;
          this._groups.forEach((group) => {
            const top = this._visible.get(group.id);
            if (top == null) return;
            if (best == null || top < this._visible.get(best)) best = group.id;
          });
          if (best) this._setActive(best);
        },
        { rootMargin: '-96px 0px -55% 0px', threshold: [0, 0.1, 0.5, 1] }
      );
      this._groups.forEach((group) => this._observer.observe(group));
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }

    _setActive(id) {
      this._links.forEach((link) => {
        if (link.dataset.faqNav === id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Footer columns: always expanded on desktop, collapsible accordions on mobile
  (() => {
    const mobile = window.matchMedia('(max-width: 989px)');
    const sync = () => {
      document.querySelectorAll('[data-footer-accordion]').forEach((details) => {
        if (mobile.matches) {
          if (!details.hasAttribute('data-keep-open')) details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
        }
      });
    };
    sync();
    mobile.addEventListener('change', sync);
    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(sync, 150);
    }, { passive: true });
  })();

  document.querySelectorAll('[data-footer-language]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  // Cookie settings: reopens the preferences of Shopify's cookie banner, so visitors can change or withdraw consent
  (() => {
    const items = document.querySelectorAll('[data-cookie-settings]');
    if (!items.length) return;
    const available = () => typeof window.privacyBanner?.showPreferences === 'function';
    items.forEach((item) => {
      item.querySelector('button')?.addEventListener('click', () => {
        if (available()) window.privacyBanner.showPreferences();
      });
    });
    // The banner script loads async; check after page load and retry briefly in case it is injected late
    let tries = 0;
    const reveal = () => {
      if (available()) {
        items.forEach((item) => { item.hidden = false; });
      } else if (tries++ < 10) {
        window.setTimeout(reveal, 500);
      }
    };
    if (document.readyState === 'complete') reveal();
    else window.addEventListener('load', reveal, { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
